<template>
  <div class="select-container" v-click-outside="closeDropdown">
    <div
      class="select-box"
      @click="toggleDropdown"
      :class="{
        'openDropdown': this.isDropdownOpen,
        'smallContainer': this.size == 'small',
      }"
    >
      <span :class="{ 'smallText': this.size == 'small' }">{{
        selectedItem || title
      }}</span>
      <ChevronDown
        color="#808080"
        class="chevron"
        :class="{ flip_chevron: isDropdownOpen }"
      />
    </div>
    <ul
      v-if="isDropdownOpen"
      class="select-dropdown"
      :class="{ 'drop-up': openUpward }"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        @click="selectItem(item)"
        :class="{ 'selected_li': this.selectedItem == item }"
      >
        <p>{{ item }}</p>
        <span class="selectedCheck" v-if="this.selectedItem == item">
          <Check color="white" size="16"
        /></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { ChevronDown, Check } from "lucide-vue-next";

export default {
  name: "Select",
  components: {
    ChevronDown,
    Check,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: String,
    size: String,
    selected: String,
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedItem: this.selected,
      openUpward: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;

      this.$nextTick(() => {
        const rect = this.$el.getBoundingClientRect();
        const distanceFromBottom = window.innerHeight - rect.bottom;

        this.openUpward = distanceFromBottom < 150;
      });
    },
    selectItem(item) {
      this.selectedItem = item;
      console.log(this.selectedItem);
      this.isDropdownOpen = false;
      this.$emit("selectedItem", item);
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el.clickOutsideHandler = (event) => {
          if (!el.contains(event.target)) {
            binding.value(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideHandler);
      },
      unmounted(el) {
        document.body.removeEventListener("click", el.clickOutsideHandler);
      },
    },
  },
};
</script>

<style scoped>
.select-container {
  position: relative;
  user-select: none;
}
.smallContainer {
  height: 15px;
  /* width: fit-content; */
  width: 120px;
}
.smallText {
  font-size: 15px;
}
.select-box {
  padding: 7px 3px 7px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 7px;
}

.select-box:hover {
  border: thin solid #721cff;
}
.select-box:active {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.openDropdown {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  background-color: white;
  max-height: 150px;
  overflow-y: auto;
  margin-top: 5px;
  list-style: none;
  padding: 3px;
  z-index: 10;
  border-radius: 7px;
  width: 200px;
}

.select-dropdown li {
  padding: 10px;
  cursor: pointer;
  margin: 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select-dropdown li:hover {
  background-color: #721cff10;
  margin: 0;
}

.selected_li {
  background-color: #721cff10;
}
.selected_li:hover {
  background-color: #721cff20 !important;
}

.arrow {
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  width: 6px;
  height: 6px;
}
.chevron {
  transition: ease-in-out 0.1s;
}
.flip_chevron {
  transform: rotate(-90deg);
}
.selectedCheck {
  background: #721cff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}
.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>
